import { Injectable } from "@angular/core";
import { PromiseLookupService } from "../../impl/PromiseLookupService";
import { ICustomFieldPromiseLookupService } from "../ICustomFieldPromiseLookupService";
import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

export abstract class CustomFieldPromiseLookupService
  extends PromiseLookupService<string, CubiqTS.CustomFieldImpl>
  implements ICustomFieldPromiseLookupService
{
  constructor() {
    super();
  }

  abstract getCustomField(fieldName: string): Promise<CubiqTS.CustomFieldImpl>;
  abstract getCustomFieldOrdinal(field: CubiqTS.CustomFieldImpl): Promise<number>;
  abstract getAllCustomFields(): Promise<Array<CubiqTS.CustomFieldImpl>>;
  abstract getActiveCustomFields(): Promise<Array<CubiqTS.CustomFieldImpl>>;
  abstract isEnabled(fieldName: string): Promise<boolean>;
}
